'use client';

import { Trans } from 'react-i18next';
import { _DefaultNamespace, TransProps } from 'react-i18next/TransWithoutContext';
import { HTMLProps } from 'react';

import { useClientTranslation } from '@/lib/i18n/client';

import type { Namespace, ParseKeys, TOptions } from 'i18next';

export function I18nTrans<
  Key extends ParseKeys<Ns, TOpt, KPrefix>,
  Ns extends Namespace = _DefaultNamespace,
  KPrefix = undefined,
  TContext extends string | undefined = undefined,
  TOpt extends TOptions & { context?: TContext } = { context: TContext },
  E = HTMLProps<HTMLDivElement>,
>({ children, ...props }: Omit<TransProps<Key, Ns, KPrefix, TContext, TOpt, E>, 't' | 'i18n'>) {
  const { t, i18n } = useClientTranslation(props.ns as string);
  return (
    // @ts-ignore
    <Trans t={t} i18n={i18n} {...props}>
      {children}
    </Trans>
  );
}
